<template>

    <MenuUserModuleMain/>
    <MenuBlank/>
    <HeadingOverviewDashboard/>

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">
                    <h2>Hello {{ this.profile.firstName }}</h2>
                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuUserModuleMain from "@/components/menu/usermodule/MenuUserModuleMain.vue";
import HeadingOverviewDashboard from "@/components/heading/common/HeadingOverviewHome.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuBlank from "@/components/menu/common/MenuBlank.vue";

export default {
    components: {
        MenuBlank,
        MenuUserModuleMain,
        IsoEvolveFooter, HeadingOverviewDashboard
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[PmOverviewDashboard][mounted] System is active.");
                console.log("[PmOverviewDashboard][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[PmOverviewDashboard][mounted] System is NOT active.");
                console.log("[PmOverviewDashboard][mounted] Error = ", e);

                this.userStore.clearUser;
                this.$router.push("login");
            });

        if (this.userStore.user === undefined) {
            console.log("[PmOverviewDashboard][mounted] User is NOT defined.");

            this.userStore.clearUser;
            this.$router.push('login');
        } else {
            console.log("[PmOverviewDashboard][mounted] User is defined. this.userStore.user.id = ", this.userStore.user.id);

            UserService.getUser(this.userStore.user.id)
                .then(data => {
                    this.profile = data.data;
                    console.log("[PmOverviewDashboard][mounted] Data = ", data);

                })
                .catch(e => {
                    console.log("[PmOverviewDashboard][mounted] No user data found.");
                    console.log("[PmOverviewDashboard][mounted] Error = ", e);

                    this.userStore.clearUser;
                    this.$router.push('login');
                });
        }
    },
    data() {

        return {
            profile: {},
        }
    },
    methods: {
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
